import React from 'react';
import I18n from 'i18n-js';
import Spinner from '@/components/common/Spinner';
import cn from '@/utils/cn';

// Spinner's icon is fa-2x (2em), so the wrapper's font size is half the requested icon size.
const Loading = ({ className, size }: { className?: string, size: number }) => (
  <div
    aria-label={I18n.t('loading')}
    className={cn('tw-flex tw-justify-center', className)}
    role="status"
    style={{ fontSize: size / 2 }}
  >
    <Spinner />
  </div>
);

export default Loading;
